import { Sort } from '../types/Sort';
import { PhoneColorsType } from '../types/PhoneColorsType';

export const SORT_OPTIONS: Sort = {
  Newest: 'age',
  Alphabetically: 'name',
  Cheapest: 'price',
};

export const ITEMS_PER_PAGE = ['4', '8', '16', 'All'];

export const PHONE_COLORS: PhoneColorsType = {
  black: '#202020',
  coral: '#e4664f',
  gold: '#fbd7bd',
  green: '#ade1cd',
  midnightgreen: '#4e5850',
  purple: '#d1cddb',
  red: '#ba0c2f',
  rosegold: '#fddcd7',
  silver: '#ebebe3',
  spacegray: '#5f5f5f',
  white: '#f9f6ef',
  yellow: '#ffe680',
};

export const sliderImageSize = {
  height: 432,
  width: 1040,
};
